import { Component, OnInit } from "@angular/core";
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { AsReportedIssuer } from "src/api/models";
import { MapInsiderDataComponent } from "../map-insider-data/map-insider-data.component";
import { MessageService } from "primeng/api";
import { MapDataComponent } from "../map-data/map-data.component";

@Component({
  selector: "app-view-data",
  // imports: [],
  templateUrl: "./view-data.component.html",
  styleUrl: "./view-data.component.css",
  standalone: false,
})
export class ViewMapDataComponent implements OnInit {
  issuerDetails: AsReportedIssuer[] = [];
  noRecord = false;
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.issuerDetails = this.config.data.issuerData || [];
    this.noRecord = this.config.data?.noRecord || false;
  }

  onCancel() {
    this.ref.close();
  }

  onRevertIssuer(issuer: any) {
    this.ref.close({ revertIssuer: issuer });
  }
}
